import React from "react";
import { ShieldAlert, ArrowLeft, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function AccessDenied({ message }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-6 py-12">
      <div className="w-full max-w-md text-center space-y-6 bg-card border border-border/60 rounded-3xl p-8 shadow-sm">
        <div className="inline-flex p-4 bg-destructive/10 rounded-full text-destructive animate-pulse">
          <ShieldAlert className="w-12 h-12" strokeWidth={2} />
        </div>
        
        <div className="space-y-2">
          <h1 className="font-display text-3xl font-black tracking-tighter text-primary">Content Blocked</h1>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {message || "You do not have the required permissions to view this section of ShreeHomes."}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 pt-4">
          <Button 
            variant="outline" 
            onClick={() => navigate(-1)} 
            className="flex-1 font-semibold gap-2"
          >
            <ArrowLeft className="w-4 h-4" /> Go Back
          </Button>
          <Button 
            onClick={() => navigate("/")} 
            className="flex-1 font-bold gap-2"
          >
            <Home className="w-4 h-4" /> Go to Home
          </Button>
        </div>
      </div>
    </div>
  );
}
